import { FC } from 'react';

import { Shield, ShieldBan } from 'lucide-react';
import { isNonNullish, isNullish } from 'remeda';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { userService } from 'v2/api/userService';
import { LONG_DASH } from 'v2/constants';
import { CheaterModel } from 'v2/types/CheaterModel';
import { handleHttpError } from 'v2/utils';

interface CheaterActionsColumnProps {
  cheater: CheaterModel;
  onRevalidate: VoidFunction;
}

export const CheaterActionsColumn: FC<CheaterActionsColumnProps> = ({ cheater, onRevalidate }) => {
  const { trigger } = useSWRMutation(cheater.user && ['updateUser', cheater.user.id], userService.updateUser, {
    onSuccess: (user) => {
      onRevalidate();
      toast.success(`User ${cheater.userNickname} was ${user.isBanned ? 'banned' : 'unbanned'}`);
    },
    onError: handleHttpError,
  });

  const handleBan = (isBanned: boolean) => () => {
    if (isNonNullish(cheater.user)) {
      trigger({ isBanned });
    }
  };

  if (isNullish(cheater.user)) {
    return LONG_DASH;
  }

  return cheater.user.isBanned ? (
    <Button onClick={handleBan(false)} startIcon={<Shield width={18} height={18} />} variant="contained">
      Unban User
    </Button>
  ) : (
    <Button
      onClick={handleBan(true)}
      startIcon={<ShieldBan width={18} height={18} />}
      variant="contained"
      color="error"
    >
      Ban User
    </Button>
  );
};
